import { render, staticRenderFns } from "./CardContentDefaultPublic.vue?vue&type=template&id=08113db0&scoped=true&"
import script from "./CardContentDefaultPublic.vue?vue&type=script&lang=js&"
export * from "./CardContentDefaultPublic.vue?vue&type=script&lang=js&"
import style0 from "./CardContentDefaultPublic.vue?vue&type=style&index=0&id=08113db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08113db0",
  null
  
)

export default component.exports